export const themesOptions = [
    {
        name: 'DEFAULT',
        value: 'DEFAULT',
    },
    {
        name: 'DARK',
        value: 'DARK',
    },
];
